import { render, staticRenderFns } from "./Ages.vue?vue&type=template&id=41707e97&"
import script from "./Ages.vue?vue&type=script&lang=js&"
export * from "./Ages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports